import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AuthState, AuthUser } from './types';

const initialState: AuthState = {
	isAuthorized: false,
	user: null,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuth(state, action: PayloadAction<AuthUser>) {
			state.isAuthorized = true;
			state.user = action.payload;
		},
		resetAuth(state) {
			state.isAuthorized = false;
			state.user = null;
		},
	},
});

export const { setAuth, resetAuth } = authSlice.actions;
export const authReducer = authSlice.reducer;
